module.exports = "<div class=\"wrapper wrapper-content animated fadeIn\" id=\"user-learning-events-container\">\n\t<div class=\"row\">\n\t<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" >\n\t<progress-events></progress-events>\n\t</div>\n\t</div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/controllers/users/learning/events/template.html
// module id = 1077
// module chunks = 0